const auth_status = {
    page_title: '인증 상태',
    title: '인증 상태',
    description: '인증 상태를 확인하세요.',
};
export default Object.freeze(auth_status);
